var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerCanal",on:{"click":_vm.selecionarCanal}},[_c('img',{staticClass:"imagemUsuarioCanal",attrs:{"src":_vm.imgUsuario}}),_vm._v(" "),_c('div',{staticClass:"lblUsuarioConversaNome"},[_vm._v(_vm._s(_vm.canal.nomeUsuario))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c10ab42","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/modulos/chat/componentes/Canais.vue
// module id = 2184
// module chunks = 0